module.exports = __webpack_public_path__ + "assets/img/platform-on-yellow-hover.jpg";